import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Environment, ENVIRONMENT } from '@netfoundry-ui/shared/model';
import { catchError, delay } from 'rxjs/operators';
import { Observable, of as observableOf } from 'rxjs';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';

import _ from 'lodash';
import { HTTP_CLIENT, TokenService } from './token.service';
import { LoggerService } from './logger.service';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class OidcOrgPublicClientMapService {
    apiUrl;
    preferences;
    preferenceId;
    organization;
    user;

    lastPageCount = 0;
    lastTotalCount = 0;
    constructor(
        private logger: LoggerService,
        private apiService: ApiService,
        private tokenService: TokenService,
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        this.apiUrl = this.environment.identityConfig.url
        this.apiService.currentTenant.subscribe((organization) => {
            this.organization = organization;
        });
        this.apiService.currentUser.subscribe((user) => {
            this.user = user;
        });
    }

    public findOidcOrgPublicClientMaps(tenantId) {
        const fullpath = `${this.apiUrl}organization-oidc-public-client-mappings` + '?organizationId='+ tenantId ;
            return this.http
                .get(fullpath)
                .pipe(catchError((error) => this.handleError(this, error)));
    }

    public findOidcOrgPublicClientMapsById(id): Observable<any> {
        const url = `${this.apiUrl}organization-oidc-public-client-mappings/${id}`;
        return this.http.get(url) as Observable<any>;
    }

    public create(model) {
        const fullpath = `${this.apiUrl}organization-oidc-public-client-mappings`;
            return this.http
                .post(fullpath, model)
    }


    public update(id, model) {
        const fullpath = `${this.apiUrl}organization-oidc-public-client-mappings/${id}`;
            return this.http
                .patch(fullpath, model)
      
    }

    public async validateCreate(model: any) {
        const headers = new HttpHeaders().set('Accept', 'application/json')
        try {
            await this.http.post(this.apiUrl + 'organization-oidc-public-client-mappings', model, {
                headers: headers,
                responseType: 'json',
            }).toPromise();
            return null; // No errors, return null
        } catch (error) {
            return error.error.errors;
        }
    }
    public validateUpdate(model: any, id: string ) {
        const headers = new HttpHeaders().set('Accept', 'application/json')
        try {
             this.http.patch(this.apiUrl + 'organization-oidc-public-client-mappings' + id, model, {
                headers: headers,
                responseType: 'json',
            }).toPromise();
            return null; // No errors, return null
        } catch (error) {
            return error.error.errors;
        }

    }


    public delete(id: string) {
        const fullpath = `${this.apiUrl}organization-oidc-public-client-mappings/${id}`;
            return this.http
                .delete(fullpath)
    }


    /**
     * Generic error handler for bad requests
     */
    protected handleError(scope: any, error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            scope.logger.error('Feature Service error occurred:', error.error);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            scope.logger.error(`Feature Backend returned code ${error.status}`, error.error);
        }
        scope.lastErrorSource.next(error);
        return observableThrowError(error);
    }


}
